import { z } from 'zod';

import { TypeBlogPost } from '../models/contentful-generated';
import { ContentfulAssetSchema } from './contentful-asset.validator';
import { ContentfulDocumentSchema } from './contentful-document.validator';
import { ContentfulSysSchema } from './contentful-sys.validator';
import { SeoMetadataEntrySchema } from './seo-metadata.validator';

export const BlogPostEntrySchema = z.object({
  sys: ContentfulSysSchema,
  fields: z.looseObject({
    title: z.string(),
    slug: z.string(),
    category: z.string(),
    excerpt: ContentfulDocumentSchema,
    image: ContentfulAssetSchema,
    author: z.string(),
    date: z.string(),
    theme: z.string(),
    seoMetadata: SeoMetadataEntrySchema.optional().nullable(),
    pageContent: z.array(z.any()).optional().nullable(),
    translations: z.record(z.string(), z.any()).optional().nullable()
  }),
  metadata: z
    .object({
      tags: z.array(z.any()).optional().nullable()
    })
    .optional()
    .nullable()
});

export function validateBlogPostEntry(data: TypeBlogPost) {
  return BlogPostEntrySchema.safeParse(data);
}

/**
 * Returns validation result.
 *
 * @param data
 */
export function validateBlogPostEntries(data: TypeBlogPost[]) {
  return z.array(BlogPostEntrySchema).safeParse(data);
}

/**
 * Returns valid entries only. In most cases, this is preferred,
 * It allows us to still show some entries instead of showing nothing when only a single entry is invalid.
 *
 * @param data
 */
export function validateAndFilterBlogPostEntries(data: TypeBlogPost[]) {
  if (!data) return [];

  return data.reduce((acc: TypeBlogPost[], entry) => {
    const validationResult = validateBlogPostEntry(entry);
    if (validationResult.success) {
      acc.push(validationResult.data as unknown as TypeBlogPost);
    } else {
      console.warn(
        `Validation failed for blog post entry with id: '${entry?.sys?.id}'. It will be filtered out. Error: ${validationResult.error.message}`
      );
    }
    return acc;
  }, []);
}
